import PackageListContainer from './PackageListContainer';

export default PackageListContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/PackageList/index.js